import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { currencyWithPrefix } from '../../utils/currencyUtils';

interface BankTotal {
  bank: string;
  total: number;
}

interface OperationsSummaryModalProps {
  isOpen: boolean;
  onClose: () => void;
  totalLiquidated: number;
  bankTotals: BankTotal[];
}

export const OperationsSummaryModal: React.FC<OperationsSummaryModalProps> = ({
  isOpen,
  onClose,
  totalLiquidated,
  bankTotals,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white dark:bg-slate-800 rounded-lg shadow-xl w-full max-w-2xl mx-4">
        <div className="flex items-center justify-between p-4 border-b dark:border-slate-700">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
            Resumo de Operações
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
          >
            <FaTimes size={20} />
          </button>
        </div>

        <div className="p-6 space-y-6">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-3">
            Total Liquidado
          </h3>
          <div className="bg-blue-50 dark:bg-slate-700 p-4 rounded-lg">
            <p className="text-2xl font-bold text-blue-600 dark:text-blue-400 text-right">
              {currencyWithPrefix(totalLiquidated)}
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-3">
              Total Liquidado por Instituição
            </h3>
            <div className="space-y-2">
              {bankTotals.map((item, index) => (
                <div
                  key={index}
                  className="flex justify-between items-center p-3 bg-gray-50 dark:bg-slate-700 rounded"
                >
                  <span className="text-gray-700 dark:text-gray-300">{item.bank}</span>
                  <span className="font-semibold text-gray-900 dark:text-gray-100">
                    {currencyWithPrefix(item.total)}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="flex justify-end p-4 border-t dark:border-slate-700">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
};
